export function initParallax(container) {

  //console.log('Init Parallax');

  const newContainer = $(container);
  const btnNext = newContainer.find('.btn-next');
  let sy;

  //OnScroll
  window.addEventListener('scroll', scroll);

  function scroll() {

    sy = window.pageYOffset;
    TweenMax.to(newContainer.find('.prllx-visuel'), 0.5, {y: sy*0.1 })
    TweenMax.to(newContainer.find('.prllx-form'), 0.5, {y: -sy*0.2 })
    TweenMax.to(newContainer.find('.binary-1, .binary-3'), 0.5, {y: -sy*0.2 + 150})
    TweenMax.to(newContainer.find('.binary-2, .binary-4'), 0.5, {y: -sy*0.1 + 150})

  }

  newContainer.find('.block-content').each((index, elem) => {

    if ($(elem).find('.intro').length > 0) {
      let introSplitText = new SplitText( $(elem).find('.intro'), {type:"words"});
    }

    if ($(elem).find('.highlight').length > 0) {
      let introSplitText = new SplitText( $(elem).find('.highlight'), {type:"words, chars"});
    }

    TweenMax.set($(elem).find('p.intro div'), {opacity:0, x:20});
    TweenMax.set($(elem).find('> p, > a'), {opacity:0, x:75});
    TweenMax.set($(elem).find('.highlight div > div'), {y:100});

  });
  newContainer.find('.visuel-container.animated').each((index, elem) => {

    if ($(elem).find('.binary').length > 0) {
      let introSplitText = new SplitText( $(elem).find('.binary'), {type:"lines, chars"});
    }

    TweenMax.set($(elem).find('.revealer'), {x:"-100%"});
    TweenMax.set($(elem).find('.visuel'), {x:"-100%"});
    TweenMax.set($(elem).find('.zoom-line'), {opacity:0});
    TweenMax.set($(elem).find('.zoom-line .line'), {width:0, height:0});
    TweenMax.set($(elem).find('.zoom-line svg path'), {drawSVG:"0%"});
    TweenMax.set($(elem).find('.binary div > div'), {y:100});

  });

  setTimeout(() => {

    newContainer.find('.block-content.animated').viewportChecker({

      repeat:false,
      classToAdd: 'visible',
      classToAddForFullView: '',
      offset:0,
      callbackFunction: function(elem, action){

        let revealTimeline = new TimelineMax({ paused: true });
        revealTimeline.set(elem.find('p.intro div'), {opacity:0, x:20});
        revealTimeline.set(elem.find('> p, > a'), {opacity:0, x:75});
        revealTimeline.set(elem.find('.highlight div > div'), {y:100});
        revealTimeline.staggerTo(elem.find('p.intro div'), 2, {opacity:1, x:0,  ease:Power3.easeOut}, 0.05, 0)
        revealTimeline.staggerTo(elem.find('> p, > a'), 2, {opacity:1, x:0,  ease:Power3.easeOut}, 0.05, 0)
        revealTimeline.staggerTo(elem.find('.highlight div > div'), 1, {y:0,  ease:Power3.easeOut}, 0.02, 0)

        if (action == "add" ) {

          if (!elem.hasClass('reveal')) {
            revealTimeline.restart();
          }
          elem.addClass('reveal');

        } else {

          elem.removeClass('reveal');

        }

      }
    });

    newContainer.find('.visuel-container.animated').viewportChecker({

      repeat:false,
      classToAdd: 'visible',
      classToAddForFullView: '',
      offset:0,
      callbackFunction: function(elem, action){

        let revealTimeline = new TimelineMax({ paused: true });

        revealTimeline.set(elem.find('.revealer'), {x:"-100%"});
        revealTimeline.set(elem.find('.visuel'), {x:"-100%"});
        revealTimeline.set(elem.find('.zoom-line'), {opacity:0});
        revealTimeline.set(elem.find('.zoom-line .line'), {width:0, height:0});
        revealTimeline.set(elem.find('.zoom-line svg path'), {drawSVG:"0%"});
        revealTimeline.set(elem.find('.binary div > div'), {y:100});
        revealTimeline.to(elem.find('.revealer'), 1, {x:"0%", ease:Power3.easeInOut}, 0);
        revealTimeline.to(elem.find('.visuel'), 1, {x:"-25%", ease:Power3.easeInOut}, 0);
        revealTimeline.to(elem.find('.visuel'), 1, {x:"0%", ease:Power3.easeInOut}, 1);
        revealTimeline.to(elem.find('.revealer'), 1, {x:"100%", ease:Power3.easeInOut}, 1);
        revealTimeline.staggerTo(elem.find('.zoom-line'), 1, {opacity:1, ease:Power3.easeInOut}, 0.3, 1)
        revealTimeline.staggerTo(elem.find('.zoom-line svg path'), 1, {drawSVG:"100%", ease:Power3.easeInOut}, 0.3, 1)
        revealTimeline.staggerTo(elem.find('.zoom-line .line'), 1, {width:"100%", height:"100%", ease:Power3.easeInOut}, 0.3, 1.3)
        revealTimeline.staggerTo(elem.find('.binary div > div'), 1, {y:0,  ease:Power3.easeOut}, 0.02, 0)


        if (action == "add" ) {

          if (!elem.hasClass('reveal')) {
            revealTimeline.restart();
          }
          elem.addClass('reveal');

        } else {

          elem.removeClass('reveal');

        }
      },
    })

  }, 1400);


  const tlNext = new TimelineMax({ paused: true});
  tlNext.from(btnNext.find(' > .wrapper .icon svg'), 1, {y:-100}, 0);
  tlNext.from(btnNext.find(' > .wrapper'), 1, {y:-200}, 0);
  tlNext.from(btnNext.find(' > .bg'), 1, {y:-150}, 0);

  TweenMax.ticker.addEventListener("tick", render, this, true, 1);

  function render() {

    //Music
    if (btnNext.length > 0) {
      let nextMin = btnNext.offset().top - window.innerHeight;
      let nextMax = btnNext.offset().top + btnNext.outerHeight() - window.innerHeight;
  		let nextNorm = clamp(normalize(sy, nextMin, nextMax), 0, 1);
      tlNext.progress(nextNorm);
    }


  }

  //utils
  function normalize(value, min, max) {
  	return (value - min) / (max - min);
  }

  function clamp(value, min, max) {
  	return value < min ? min : (value > max ? max : value);
  }

}
